import BaseAPIService from '@/services/baseAPIService'

export default class PurchasingAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  createPurchaseOrder(data)                   { return this.httpClient.post(`/purchasing/purchaseorders`, data) }
  getPurchaseOrder(id)                        { return this.httpClient.get(`/purchasing/purchaseorders/${id}`) }
  getPurchaseOrderFilteredList(options = {}) {
    var params = {
      filter: options.filter || {}
    }
    if(options.order)
      params.order = options.order
    if(options.columns)
      params.columns = options.columns
    if(options.search)
      params.search = options.search
    
    var queryString = '/purchasing/purchaseorders?' + $.param(params)

    return this.httpClient.get(queryString)
  }
  updatePurchaseOrder(id, data)               { return this.httpClient.put(`/purchasing/purchaseorders/${id}`, data) }

  approvePurchaseOrder(id, data)              { return this.httpClient.post(`/purchasing/purchaseorders/${id}/approve`, data) }
  approvePurchaseOrderAmendment(id)           { return this.httpClient.post(`/purchasing/purchaseorders/${id}/approveamendment`) }
  denyPurchaseOrder(id, data)                 { return this.httpClient.post(`/purchasing/purchaseorders/${id}/deny`, data) }
  cancelPurchaseOrder(id, data)               { return this.httpClient.post(`/purchasing/purchaseorders/${id}/cancel`, data) }

  resendPurchaseOrder(id, data)               { return this.httpClient.post(`/purchasing/purchaseorders/${id}/resend`, data) }

  supplierConfirmedPurchaseOrder(id, data)    { return this.httpClient.post(`/purchasing/purchaseorders/${id}/supplierconfirm`, data) }
  supplierShippedPurchaseOrder(id, data)      { return this.httpClient.post(`/purchasing/purchaseorders/${id}/suppliershipped`, data) }
  updateAdvisedReceivingPurchaseOrder(id, data) { return this.httpClient.post(`/purchasing/purchaseorders/${id}/advisedreceiving`, data) }
  updateAdvisedShippingPurchaseOrder(id, data) { return this.httpClient.post(`/purchasing/purchaseorders/${id}/advisedshipping`, data) }
  updatePurchaseOrderReferences(id, data)     { return this.httpClient.put(`/purchasing/purchaseorders/${id}/references`, data) }
  shipmentReceivedPurchaseOrder(id)           { return this.httpClient.post(`/purchasing/purchaseorders/${id}/shipmentreceived`) }
  pickupReadyPurchaseOrder(id)                { return this.httpClient.post(`/purchasing/purchaseorders/${id}/pickupready`) }
  skipPendingPickup(id, data)                 { return this.httpClient.post(`/purchasing/purchaseorders/${id}/skippendingpickup`, data) }

  updatePurchaseOrderGoodsReceived(id, data)  { return this.httpClient.put(`/purchasing/purchaseorders/${id}/receiving`, data) }
  completePurchaseOrderGoodsReceived(id, data){ return this.httpClient.post(`/purchasing/purchaseorders/${id}/receiving/complete`, data) }

  getPurchaseOrderApprovalContactPeople(id, contactLabelIDList) {
    var params = { contactLabelIDList: contactLabelIDList }
    return this.httpClient.get(`/purchasing/purchaseorders/${id}/approvalcontactpeople?${$.param(params)}`)
  }
  getPurchaseOrderApprovalTemplate(id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/purchasing/purchaseorders/${id}/approvaltemplate?${$.param(params)}`)
  }

  // Purchasing Optimiser
  optimiserStockPurchasingList(data) {
    return this.reportingHttpClient.post(`/purchasing/purchaseorders/optimiser/calculate`, data)
  }

}